fetch(`https://widget.trustpilot.com/trustbox-data/53aa8807dec7e10d38f59f32?businessUnitId=61182f0a3d6395001d4975b2&locale=${window.Shopify.locale}-${window.Shopify.country}`)
  .then(response => response.json())
  .then(response => {
    if (response.businessUnit.numberOfReviews.total > 0) {
      document.querySelectorAll('.trustCount').forEach(el => el.innerHTML = response.businessUnit.numberOfReviews.total);
      document.querySelectorAll('.trustStar').forEach(el => el.innerHTML = response.businessUnit.trustScore);
    } else {
      document.querySelectorAll('.product-info__trust').forEach(el => el.style.display = 'none');
    }
  });
document.addEventListener('DOMContentLoaded', function() {
  // Event delegation for accordion click event
  document.addEventListener('click', function(event) {
    if (event.target.closest('.accordion_head')) {
      const accordionHead = event.target.closest('.accordion_head');
      const accordionBody = accordionHead.nextElementSibling;
      const plusMinusIcon = accordionHead.querySelector('.plusminus');

      if (accordionBody.style.display === 'block') {
        accordionBody.style.display = 'none';
        plusMinusIcon.src = 'https://cdn.shopify.com/s/files/1/0561/6431/9440/files/plus-svgrepo-com.svg?v=1700565664';
      } else {
        // Hide all accordion bodies
        document.querySelectorAll('.accordion_body').forEach(body => body.style.display = 'none');
        // Update all plus/minus icons
        document.querySelectorAll('.plusminus').forEach(icon => icon.src = 'https://cdn.shopify.com/s/files/1/0561/6431/9440/files/plus-svgrepo-com.svg?v=1700565664');

        // Show the clicked accordion body
        accordionBody.style.display = 'block';
        plusMinusIcon.src = 'https://cdn.shopify.com/s/files/1/0561/6431/9440/files/minus-svgrepo-com_2.svg?v=1700565663';
      }
    }
  });

  // Resize event handler
  window.addEventListener('resize', function() {
    const viewportWidth = window.innerWidth;

    const accordionBodies = document.querySelectorAll('.accordion_body');

    viewportWidth >= 767 ? accordionBodies.forEach(body => body.style.display = 'block') : accordionBodies.forEach(body => body.style.display = 'none');
  });

  // Trigger the resize event on page load
  window.dispatchEvent(new Event('resize'));
});

document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('[data-open-level]');
  const containers = document.querySelectorAll('[data-level]');
  let activeContainer = null;

  links.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const level = link.getAttribute('data-open-level');
      const target = document.querySelector(`[data-level="${level}"]`);
      if (target) {
        target.classList.add('active');
        activeContainer = target;
      }
    });

    link.addEventListener('mouseleave', () => {
      const level = link.getAttribute('data-open-level');
      const target = document.querySelector(`[data-level="${level}"]`);
      if (target) {
        setTimeout(() => {
          if (!target.matches(':hover')) {
            target.classList.remove('active');
            activeContainer = null;
          }
        }, 50);
      }
    });
  });

  containers.forEach(container => {
    container.addEventListener('mouseleave', () => {
      container.classList.remove('active');
      activeContainer = null;
    });
  });
});
